/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddCarveOutQuote201Response,
    AddCarveOutQuote201ResponseFromJSON,
    AddCarveOutQuote201ResponseToJSON,
} from '../models/AddCarveOutQuote201Response';
import {
    type AddCarveOutQuoteRequest,
    AddCarveOutQuoteRequestFromJSON,
    AddCarveOutQuoteRequestToJSON,
} from '../models/AddCarveOutQuoteRequest';
import {
    type AddDocumentToPalAuthSubmission201Response,
    AddDocumentToPalAuthSubmission201ResponseFromJSON,
    AddDocumentToPalAuthSubmission201ResponseToJSON,
} from '../models/AddDocumentToPalAuthSubmission201Response';
import {
    type AddDocumentToPalAuthSubmissionRequest,
    AddDocumentToPalAuthSubmissionRequestFromJSON,
    AddDocumentToPalAuthSubmissionRequestToJSON,
} from '../models/AddDocumentToPalAuthSubmissionRequest';
import {
    type AuthPlatformRemotePatientSearchPayload,
    AuthPlatformRemotePatientSearchPayloadFromJSON,
    AuthPlatformRemotePatientSearchPayloadToJSON,
} from '../models/AuthPlatformRemotePatientSearchPayload';
import {
    type AutosavePalAuthSubmission200Response,
    AutosavePalAuthSubmission200ResponseFromJSON,
    AutosavePalAuthSubmission200ResponseToJSON,
} from '../models/AutosavePalAuthSubmission200Response';
import {
    type AutosavePalAuthSubmission409Response,
    AutosavePalAuthSubmission409ResponseFromJSON,
    AutosavePalAuthSubmission409ResponseToJSON,
} from '../models/AutosavePalAuthSubmission409Response';
import {
    type AutosavePalAuthSubmissionRequest,
    AutosavePalAuthSubmissionRequestFromJSON,
    AutosavePalAuthSubmissionRequestToJSON,
} from '../models/AutosavePalAuthSubmissionRequest';
import {
    type CarveOutSelectionRequest,
    CarveOutSelectionRequestFromJSON,
    CarveOutSelectionRequestToJSON,
} from '../models/CarveOutSelectionRequest';
import {
    type CarveOutTransitionRequest,
    CarveOutTransitionRequestFromJSON,
    CarveOutTransitionRequestToJSON,
} from '../models/CarveOutTransitionRequest';
import {
    type CreateCarveOut201Response,
    CreateCarveOut201ResponseFromJSON,
    CreateCarveOut201ResponseToJSON,
} from '../models/CreateCarveOut201Response';
import {
    type CreateCarveOutRequest,
    CreateCarveOutRequestFromJSON,
    CreateCarveOutRequestToJSON,
} from '../models/CreateCarveOutRequest';
import {
    type CreatePalReauthCaseManager201Response,
    CreatePalReauthCaseManager201ResponseFromJSON,
    CreatePalReauthCaseManager201ResponseToJSON,
} from '../models/CreatePalReauthCaseManager201Response';
import {
    type CreatePalReauthCaseManagerRequest,
    CreatePalReauthCaseManagerRequestFromJSON,
    CreatePalReauthCaseManagerRequestToJSON,
} from '../models/CreatePalReauthCaseManagerRequest';
import {
    type CreatePalReauthReportGeneration201Response,
    CreatePalReauthReportGeneration201ResponseFromJSON,
    CreatePalReauthReportGeneration201ResponseToJSON,
} from '../models/CreatePalReauthReportGeneration201Response';
import {
    type CreatePalReauthSubmission201Response,
    CreatePalReauthSubmission201ResponseFromJSON,
    CreatePalReauthSubmission201ResponseToJSON,
} from '../models/CreatePalReauthSubmission201Response';
import {
    type CreatePalReauthSubmissionRequest,
    CreatePalReauthSubmissionRequestFromJSON,
    CreatePalReauthSubmissionRequestToJSON,
} from '../models/CreatePalReauthSubmissionRequest';
import {
    type CreatePalSubmissionRequest,
    CreatePalSubmissionRequestFromJSON,
    CreatePalSubmissionRequestToJSON,
} from '../models/CreatePalSubmissionRequest';
import {
    type CreatePayerContracts201Response,
    CreatePayerContracts201ResponseFromJSON,
    CreatePayerContracts201ResponseToJSON,
} from '../models/CreatePayerContracts201Response';
import {
    type FindAllCarveOutTracking200Response,
    FindAllCarveOutTracking200ResponseFromJSON,
    FindAllCarveOutTracking200ResponseToJSON,
} from '../models/FindAllCarveOutTracking200Response';
import {
    type FindCarveOutTrackingPresetCounts200Response,
    FindCarveOutTrackingPresetCounts200ResponseFromJSON,
    FindCarveOutTrackingPresetCounts200ResponseToJSON,
} from '../models/FindCarveOutTrackingPresetCounts200Response';
import {
    type FindAllCarveOuts200Response,
    FindAllCarveOuts200ResponseFromJSON,
    FindAllCarveOuts200ResponseToJSON,
} from '../models/FindAllCarveOuts200Response';
import {
    type FindAllPalAuthIntegrationsForLead200Response,    FindAllPalAuthIntegrationsForLead200ResponseFromJSON,
    FindAllPalAuthIntegrationsForLead200ResponseToJSON,
} from '../models/FindAllPalAuthIntegrationsForLead200Response';
import {
    type FindAllPalAuthPlatforms200Response,
    FindAllPalAuthPlatforms200ResponseFromJSON,
    FindAllPalAuthPlatforms200ResponseToJSON,
} from '../models/FindAllPalAuthPlatforms200Response';
import {
    type FindAllPalReauthCaseManagers200Response,
    FindAllPalReauthCaseManagers200ResponseFromJSON,
    FindAllPalReauthCaseManagers200ResponseToJSON,
} from '../models/FindAllPalReauthCaseManagers200Response';
import {
    type FindAllPalReauthSubmissions200Response,
    FindAllPalReauthSubmissions200ResponseFromJSON,
    FindAllPalReauthSubmissions200ResponseToJSON,
} from '../models/FindAllPalReauthSubmissions200Response';
import {
    type FindAllPalSubmissions200Response,
    FindAllPalSubmissions200ResponseFromJSON,
    FindAllPalSubmissions200ResponseToJSON,
} from '../models/FindAllPalSubmissions200Response';
import {
    type FindOnePalInfo200Response,
    FindOnePalInfo200ResponseFromJSON,
    FindOnePalInfo200ResponseToJSON,
} from '../models/FindOnePalInfo200Response';
import {
    type FindPalSubmissionPresetCounts200Response,
    FindPalSubmissionPresetCounts200ResponseFromJSON,
    FindPalSubmissionPresetCounts200ResponseToJSON,
} from '../models/FindPalSubmissionPresetCounts200Response';
import {
    type GenerateEligibilityCheckReport200Response,
    GenerateEligibilityCheckReport200ResponseFromJSON,
    GenerateEligibilityCheckReport200ResponseToJSON,
} from '../models/GenerateEligibilityCheckReport200Response';
import {
    type GetEligibilityChecks200Response,
    GetEligibilityChecks200ResponseFromJSON,
    GetEligibilityChecks200ResponseToJSON,
} from '../models/GetEligibilityChecks200Response';
import {
    type GetEnabledPayers200Response,
    GetEnabledPayers200ResponseFromJSON,
    GetEnabledPayers200ResponseToJSON,
} from '../models/GetEnabledPayers200Response';
import {
    type GetExaCarePayerList200Response,
    GetExaCarePayerList200ResponseFromJSON,
    GetExaCarePayerList200ResponseToJSON,
} from '../models/GetExaCarePayerList200Response';
import {
    type GetInovalonPayerList200Response,
    GetInovalonPayerList200ResponseFromJSON,
    GetInovalonPayerList200ResponseToJSON,
} from '../models/GetInovalonPayerList200Response';
import {
    type GetInovalonPayerSearchOptions200Response,
    GetInovalonPayerSearchOptions200ResponseFromJSON,
    GetInovalonPayerSearchOptions200ResponseToJSON,
} from '../models/GetInovalonPayerSearchOptions200Response';
import {
    type GetLatestPalSubmission200Response,
    GetLatestPalSubmission200ResponseFromJSON,
    GetLatestPalSubmission200ResponseToJSON,
} from '../models/GetLatestPalSubmission200Response';
import {
    type GetLeadAssessmentForm200Response,
    GetLeadAssessmentForm200ResponseFromJSON,
    GetLeadAssessmentForm200ResponseToJSON,
} from '../models/GetLeadAssessmentForm200Response';
import {
    type GetMedicareAssessmentFormOptions200Response,
    GetMedicareAssessmentFormOptions200ResponseFromJSON,
    GetMedicareAssessmentFormOptions200ResponseToJSON,
} from '../models/GetMedicareAssessmentFormOptions200Response';
import {
    type GetMedicareEstimates200Response,
    GetMedicareEstimates200ResponseFromJSON,
    GetMedicareEstimates200ResponseToJSON,
} from '../models/GetMedicareEstimates200Response';
import {
    type GetMedicarePtOtMappings200Response,
    GetMedicarePtOtMappings200ResponseFromJSON,
    GetMedicarePtOtMappings200ResponseToJSON,
} from '../models/GetMedicarePtOtMappings200Response';
import {
    type GetPalReauthSubmissionHistory200Response,
    GetPalReauthSubmissionHistory200ResponseFromJSON,
    GetPalReauthSubmissionHistory200ResponseToJSON,
} from '../models/GetPalReauthSubmissionHistory200Response';
import {
    type GetPayerContractRules200Response,
    GetPayerContractRules200ResponseFromJSON,
    GetPayerContractRules200ResponseToJSON,
} from '../models/GetPayerContractRules200Response';
import {
    type GetPayerContractStructuredContract200Response,
    GetPayerContractStructuredContract200ResponseFromJSON,
    GetPayerContractStructuredContract200ResponseToJSON,
} from '../models/GetPayerContractStructuredContract200Response';
import {
    type GetPayerContracts200Response,
    GetPayerContracts200ResponseFromJSON,
    GetPayerContracts200ResponseToJSON,
} from '../models/GetPayerContracts200Response';
import {
    type GetStediPayers200Response,
    GetStediPayers200ResponseFromJSON,
    GetStediPayers200ResponseToJSON,
} from '../models/GetStediPayers200Response';
import {
    type GetTimExecution200Response,
    GetTimExecution200ResponseFromJSON,
    GetTimExecution200ResponseToJSON,
} from '../models/GetTimExecution200Response';
import {
    type MarkPalAuthSubmissionAsManualRequest,
    MarkPalAuthSubmissionAsManualRequestFromJSON,
    MarkPalAuthSubmissionAsManualRequestToJSON,
} from '../models/MarkPalAuthSubmissionAsManualRequest';
import {
    type MarkPayerAsInnRequest,
    MarkPayerAsInnRequestFromJSON,
    MarkPayerAsInnRequestToJSON,
} from '../models/MarkPayerAsInnRequest';
import {
    type MedicareAssessmentForm,
    MedicareAssessmentFormFromJSON,
    MedicareAssessmentFormToJSON,
} from '../models/MedicareAssessmentForm';
import {
    type PayerContract,
    PayerContractFromJSON,
    PayerContractToJSON,
} from '../models/PayerContract';
import {
    type PayerContractUpdate,
    PayerContractUpdateFromJSON,
    PayerContractUpdateToJSON,
} from '../models/PayerContractUpdate';
import {
    type PerformEligibilityCheck200Response,
    PerformEligibilityCheck200ResponseFromJSON,
    PerformEligibilityCheck200ResponseToJSON,
} from '../models/PerformEligibilityCheck200Response';
import {
    type PerformEligibilityCheck400Response,
    PerformEligibilityCheck400ResponseFromJSON,
    PerformEligibilityCheck400ResponseToJSON,
} from '../models/PerformEligibilityCheck400Response';
import {
    type PerformEligibilityCheckRequest,
    PerformEligibilityCheckRequestFromJSON,
    PerformEligibilityCheckRequestToJSON,
} from '../models/PerformEligibilityCheckRequest';
import {
    type RetryPalAuthWithMissingInputRequest,
    RetryPalAuthWithMissingInputRequestFromJSON,
    RetryPalAuthWithMissingInputRequestToJSON,
} from '../models/RetryPalAuthWithMissingInputRequest';
import {
    type ReviewPalAuthSubmissionRequest,
    ReviewPalAuthSubmissionRequestFromJSON,
    ReviewPalAuthSubmissionRequestToJSON,
} from '../models/ReviewPalAuthSubmissionRequest';
import {
    type ScreenerInsurance,
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceToJSON,
} from '../models/ScreenerInsurance';
import {
    type SearchPalAuthPlatformRemotePatient200Response,
    SearchPalAuthPlatformRemotePatient200ResponseFromJSON,
    SearchPalAuthPlatformRemotePatient200ResponseToJSON,
} from '../models/SearchPalAuthPlatformRemotePatient200Response';
import {
    type StructuredContract,
    StructuredContractFromJSON,
    StructuredContractToJSON,
} from '../models/StructuredContract';
import {
    type SubmitPalAuthSubmissionRequest,
    SubmitPalAuthSubmissionRequestFromJSON,
    SubmitPalAuthSubmissionRequestToJSON,
} from '../models/SubmitPalAuthSubmissionRequest';
import {
    type UpdateCarveOutRequest,
    UpdateCarveOutRequestFromJSON,
    UpdateCarveOutRequestToJSON,
} from '../models/UpdateCarveOutRequest';
import {
    type UpdateEnabledPayersBulkRequest,
    UpdateEnabledPayersBulkRequestFromJSON,
    UpdateEnabledPayersBulkRequestToJSON,
} from '../models/UpdateEnabledPayersBulkRequest';
import {
    type UpdateLeadInsurances200Response,
    UpdateLeadInsurances200ResponseFromJSON,
    UpdateLeadInsurances200ResponseToJSON,
} from '../models/UpdateLeadInsurances200Response';
import {
    type UpdatePalAuthSubmissionRequest,
    UpdatePalAuthSubmissionRequestFromJSON,
    UpdatePalAuthSubmissionRequestToJSON,
} from '../models/UpdatePalAuthSubmissionRequest';
import {
    type UpdatePalReauthCaseManagerRequest,
    UpdatePalReauthCaseManagerRequestFromJSON,
    UpdatePalReauthCaseManagerRequestToJSON,
} from '../models/UpdatePalReauthCaseManagerRequest';
import {
    type UpdatePalReauthEmrDocumentSelection200Response,
    UpdatePalReauthEmrDocumentSelection200ResponseFromJSON,
    UpdatePalReauthEmrDocumentSelection200ResponseToJSON,
} from '../models/UpdatePalReauthEmrDocumentSelection200Response';
import {
    type UpdatePalReauthEmrDocumentSelectionRequest,
    UpdatePalReauthEmrDocumentSelectionRequestFromJSON,
    UpdatePalReauthEmrDocumentSelectionRequestToJSON,
} from '../models/UpdatePalReauthEmrDocumentSelectionRequest';
import {
    type UpdatePalReauthReportGenerationRequest,
    UpdatePalReauthReportGenerationRequestFromJSON,
    UpdatePalReauthReportGenerationRequestToJSON,
} from '../models/UpdatePalReauthReportGenerationRequest';
import {
    type UpdatePalReauthSubmissionRequest,
    UpdatePalReauthSubmissionRequestFromJSON,
    UpdatePalReauthSubmissionRequestToJSON,
} from '../models/UpdatePalReauthSubmissionRequest';
import {
    type ValidatePalNpi200Response,
    ValidatePalNpi200ResponseFromJSON,
    ValidatePalNpi200ResponseToJSON,
} from '../models/ValidatePalNpi200Response';
import {
    type ValidatePalNpiRequest,
    ValidatePalNpiRequestFromJSON,
    ValidatePalNpiRequestToJSON,
} from '../models/ValidatePalNpiRequest';

export interface AddCarveOutQuoteOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
    /**
     * 
     */
    addCarveOutQuoteRequest: AddCarveOutQuoteRequest;
}

export interface AddDocumentToPalAuthSubmissionOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    addDocumentToPalAuthSubmissionRequest: AddDocumentToPalAuthSubmissionRequest;
}

export interface AutosavePalAuthSubmissionOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    autosavePalAuthSubmissionRequest: AutosavePalAuthSubmissionRequest;
}

export interface CancelCarveOutRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
    /**
     * 
     */
    carveOutTransitionRequest?: CarveOutTransitionRequest;
}

export interface CreateCarveOutOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    createCarveOutRequest: CreateCarveOutRequest;
}

export interface CreatePalReauthCaseManagerOperationRequest {
    /**
     * 
     */
    createPalReauthCaseManagerRequest: CreatePalReauthCaseManagerRequest;
}

export interface CreatePalReauthReportGenerationRequest {
    /**
     * 
     */
    id: string;
}

export interface CreatePalReauthSubmissionOperationRequest {
    /**
     * 
     */
    createPalReauthSubmissionRequest: CreatePalReauthSubmissionRequest;
}

export interface CreatePalSubmissionOperationRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * 
     */
    createPalSubmissionRequest: CreatePalSubmissionRequest;
}

export interface CreatePayerContractsRequest {
    /**
     * 
     */
    payerContract: PayerContract;
}

export interface CreateTimExecutionRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface DeferCarveOutToManualRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
    /**
     * 
     */
    carveOutTransitionRequest?: CarveOutTransitionRequest;
}

export interface DeleteCarveOutRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
}

export interface DeleteCarveOutQuoteRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
    /**
     * Carve-out quote ID
     */
    quoteId: string;
}

export interface DeleteDocumentFromPalAuthSubmissionRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Document ID
     */
    documentId: string;
}

export interface DeleteEligibilityCheckByIdRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * Check ID
     */
    checkId: string;
}

export interface DeleteEnabledPayerRequest {
    /**
     * Payer ID
     */
    payerId: string;
}

export interface DeletePalReauthCaseManagerRequest {
    /**
     * 
     */
    id: string;
}

export interface DeletePayerContractByIdRequest {
    /**
     * Payer contract ID
     */
    payerContractId: string;
}

export interface FindAllCarveOutTrackingRequest {
    facilityId?: string;
    admissionStatus?: string;
    search?: string;
    limit?: number;
    page?: number;
    sortBy?: FindAllCarveOutTrackingSortByEnum;
    sortOrder?: FindAllCarveOutTrackingSortOrderEnum;
    includeEmptyAdmission?: boolean;
    payerSource?: string;
    payerType?: string;
    authPlatformIds?: string;
    includeManual?: boolean;
    includeHospital?: boolean;
    includeEfax?: boolean;
    assigneeUserIds?: string;
    unassigned?: boolean;
    carveOutStatus?: string;
    preset?: FindAllCarveOutTrackingPresetEnum;
}

export interface FindCarveOutTrackingPresetCountsRequest {
    facilityId?: string;
    admissionStatus?: string;
    search?: string;
    includeEmptyAdmission?: boolean;
    payerSource?: string;
    payerType?: string;
    authPlatformIds?: string;
    includeManual?: boolean;
    includeHospital?: boolean;
    includeEfax?: boolean;
    assigneeUserIds?: string;
    unassigned?: boolean;
}

export interface FindAllCarveOutsRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
}

export interface FindAllPalAuthIntegrationsForLeadRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface FindAllPalReauthCaseManagersRequest {
    /**
     * Search by name
     */
    search?: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface FindAllPalReauthSubmissionsRequest {
    /**
     * 
     */
    facilityId?: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
    /**
     * Comma-separated list of statuses
     */
    status?: string;
    /**
     * Comma-separated list of timing states
     */
    timingState?: string;
    /**
     * Comma-separated list of admission statuses
     */
    admissionStatus?: string;
    /**
     * 
     */
    payerSource?: string;
    /**
     * Comma-separated list of payer types
     */
    payerType?: string;
    /**
     * Search by lead name
     */
    search?: string;
    /**
     * 
     */
    sortBy?: FindAllPalReauthSubmissionsSortByEnum;
    /**
     * 
     */
    sortOrder?: FindAllPalReauthSubmissionsSortOrderEnum;
    /**
     * System-defined preset view. Applies the preset's mapped submission statuses (including the denied-by-admission split) server-side. 'all' (or omitted) applies no preset constraint.
     */
    preset?: FindAllPalReauthSubmissionsPresetEnum;
    /**
     * Comma-separated user IDs to filter by assignment (owner or liaison)
     */
    assigneeUserIds?: string;
    /**
     * When true, return only unassigned leads. Cannot be combined with assignee_user_ids.
     */
    unassigned?: boolean;
}

export interface FindAllPalSubmissionsRequest {
    /**
     * The ID of the facility
     */
    facilityId?: string;
    /**
     * 
     */
    submissionStatus?: string;
    /**
     * 
     */
    admissionStatus?: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    sortBy?: FindAllPalSubmissionsSortByEnum;
    /**
     * 
     */
    sortOrder?: FindAllPalSubmissionsSortOrderEnum;
    /**
     * Whether to include leads with empty/null admission_status
     */
    includeEmptyAdmission?: boolean;
    /**
     * Comma-separated screener_insurance_payors IDs to filter by
     */
    payerSource?: string;
    /**
     * Comma-separated insurance types to filter by (e.g. Medicare,Medicaid)
     */
    payerType?: string;
    /**
     * Comma-separated auth platform IDs to filter by (OR with include_manual)
     */
    authPlatformIds?: string;
    /**
     * Include manual submissions (submission_mode = 'manual')
     */
    includeManual?: boolean;
    /**
     * Include hospital-initiated submissions (submission_mode = 'hospital_initiated')
     */
    includeHospital?: boolean;
    /**
     * Include efax submissions (submission_mode = 'efax')
     */
    includeEfax?: boolean;
    /**
     * Comma-separated user IDs to filter by assignment (owner or liaison)
     */
    assigneeUserIds?: string;
    /**
     * When true, return only unassigned leads. Cannot be combined with assignee_user_ids.
     */
    unassigned?: boolean;
    /**
     * System-defined preset view. Applies the preset's mapped submission statuses (including the denied-by-admission split) server-side. 'all' (or omitted) applies no preset constraint.
     */
    preset?: FindAllPalSubmissionsPresetEnum;
    /**
     * Constrains the incomplete portion of submission_status by the Benefits Verified override. 'only' keeps benefits-verified rows, 'exclude' keeps the rest; omitted applies no constraint.
     */
    benefitsVerified?: FindAllPalSubmissionsBenefitsVerifiedEnum;
}

export interface FindOnePalInfoRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface FindPalReauthCaseManagerByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface FindPalReauthSubmissionByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface FindPalReauthSubmissionPresetCountsRequest {
    /**
     * The ID of the facility
     */
    facilityId?: string;
    /**
     * Comma-separated list of admission statuses
     */
    admissionStatus?: string;
    /**
     * 
     */
    payerSource?: string;
    /**
     * Comma-separated list of payer types
     */
    payerType?: string;
    /**
     * Search by lead name
     */
    search?: string;
    /**
     * Comma-separated user IDs to filter by assignment (owner or liaison)
     */
    assigneeUserIds?: string;
    /**
     * When true, count only unassigned leads. Cannot be combined with assignee_user_ids.
     */
    unassigned?: boolean;
}

export interface FindPalSubmissionPresetCountsRequest {
    /**
     * The ID of the facility
     */
    facilityId?: string;
    /**
     * 
     */
    admissionStatus?: string;
    /**
     * 
     */
    search?: string;
    /**
     * Whether to include leads with empty/null admission_status
     */
    includeEmptyAdmission?: boolean;
    /**
     * Comma-separated screener_insurance_payors IDs to filter by
     */
    payerSource?: string;
    /**
     * Comma-separated insurance types to filter by (e.g. Medicare,Medicaid)
     */
    payerType?: string;
    /**
     * Comma-separated auth platform IDs to filter by (OR with include_manual)
     */
    authPlatformIds?: string;
    /**
     * Include manual submissions (submission_mode = 'manual')
     */
    includeManual?: boolean;
    /**
     * Include hospital-initiated submissions (submission_mode = 'hospital_initiated')
     */
    includeHospital?: boolean;
    /**
     * Include efax submissions (submission_mode = 'efax')
     */
    includeEfax?: boolean;
    /**
     * Comma-separated user IDs to filter by assignment (owner or liaison)
     */
    assigneeUserIds?: string;
    /**
     * When true, count only unassigned leads. Cannot be combined with assignee_user_ids.
     */
    unassigned?: boolean;
}

export interface GenerateEligibilityCheckReportRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * Check ID
     */
    checkId: string;
}

export interface GetEligibilityCheckByIdRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * Check ID
     */
    checkId: string;
}

export interface GetEligibilityChecksRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface GetInovalonPayerSearchOptionsRequest {
    /**
     * Payer ID
     */
    payerId: string;
}

export interface GetLatestPalReauthReportGenerationRequest {
    /**
     * 
     */
    id: string;
}

export interface GetLatestPalSubmissionRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface GetLeadAssessmentFormRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface GetMedicareEstimatesRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface GetPalReauthSubmissionHistoryRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetPayerContractByIdRequest {
    /**
     * Payer contract ID
     */
    payerContractId: string;
}

export interface GetPayerContractRulesRequest {
    /**
     * Payer contract ID
     */
    payerContractId: string;
}

export interface GetPayerContractStructuredContractRequest {
    /**
     * Payer contract ID
     */
    payerContractId: string;
}

export interface GetTimExecutionRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface MarkPalAuthSubmissionAsManualOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    markPalAuthSubmissionAsManualRequest?: MarkPalAuthSubmissionAsManualRequest;
}

export interface MarkPayerAsInnOperationRequest {
    /**
     * Payer ID
     */
    payerId: string;
    /**
     * 
     */
    markPayerAsInnRequest: MarkPayerAsInnRequest;
}

export interface PerformEligibilityCheckOperationRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * 
     */
    performEligibilityCheckRequest: PerformEligibilityCheckRequest;
}

export interface RefreshPalAuthSubmissionLevelAssessmentRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
}

export interface RestartPalSubmissionRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
}

export interface RetryPalAuthWithMissingInputOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    retryPalAuthWithMissingInputRequest: RetryPalAuthWithMissingInputRequest;
}

export interface RevertCarveOutStatusRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
}

export interface RevertPalAuthSubmissionStatusRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
}

export interface RevertPalReauthSubmissionStatusRequest {
    /**
     * 
     */
    id: string;
}

export interface ReviewPalAuthSubmissionOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    reviewPalAuthSubmissionRequest?: ReviewPalAuthSubmissionRequest;
}

export interface SearchPalAuthPlatformRemotePatientRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    authPlatformRemotePatientSearchPayload: AuthPlatformRemotePatientSearchPayload;
}

export interface SetCarveOutSelectionRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    carveOutSelectionRequest: CarveOutSelectionRequest;
}

export interface SubmitPalAuthSubmissionOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    submitPalAuthSubmissionRequest: SubmitPalAuthSubmissionRequest;
}

export interface UnmarkPayerAsInnRequest {
    /**
     * Payer ID
     */
    payerId: string;
    /**
     * Facility ID
     */
    facilityId: string;
}

export interface UnmarkPayerTypeAsInnRequest {
    /**
     * Payer ID
     */
    payerId: string;
    /**
     * Facility ID
     */
    facilityId: string;
    /**
     * Insurance type
     */
    type: UnmarkPayerTypeAsInnTypeEnum;
}

export interface UpdateCarveOutOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * Carve-out ID
     */
    carveOutId: string;
    /**
     * 
     */
    updateCarveOutRequest: UpdateCarveOutRequest;
}

export interface UpdateEnabledPayersBulkOperationRequest {
    /**
     * 
     */
    updateEnabledPayersBulkRequest: UpdateEnabledPayersBulkRequest;
}

export interface UpdateLeadAssessmentFormRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * 
     */
    medicareAssessmentForm: MedicareAssessmentForm;
}

export interface UpdateLeadInsurancesRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * 
     */
    screenerInsurance: Array<ScreenerInsurance>;
}

export interface UpdatePalAuthSubmissionOperationRequest {
    /**
     * PAL Auth Submission ID
     */
    palAuthSubmissionId: string;
    /**
     * 
     */
    updatePalAuthSubmissionRequest: UpdatePalAuthSubmissionRequest;
}

export interface UpdatePalReauthCaseManagerOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updatePalReauthCaseManagerRequest: UpdatePalReauthCaseManagerRequest;
}

export interface UpdatePalReauthEmrDocumentSelectionOperationRequest {
    /**
     * screener_pal_reauth_submissions.id
     */
    id: string;
    /**
     * external_emr_documents.id
     */
    externalEmrDocumentId: string;
    /**
     * 
     */
    updatePalReauthEmrDocumentSelectionRequest: UpdatePalReauthEmrDocumentSelectionRequest;
}

export interface UpdatePalReauthReportGenerationOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    reportGenerationId: string;
    /**
     * 
     */
    updatePalReauthReportGenerationRequest: UpdatePalReauthReportGenerationRequest;
}

export interface UpdatePalReauthSubmissionOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updatePalReauthSubmissionRequest: UpdatePalReauthSubmissionRequest;
}

export interface UpdatePayerContractByIdRequest {
    /**
     * Payer contract ID
     */
    payerContractId: string;
    /**
     * 
     */
    payerContractUpdate: PayerContractUpdate;
}

export interface UpdatePayerContractStructuredContractRequest {
    /**
     * Payer contract ID
     */
    payerContractId: string;
    /**
     * 
     */
    structuredContract: StructuredContract;
}

export interface ValidatePalNpiOperationRequest {
    /**
     * 
     */
    validatePalNpiRequest: ValidatePalNpiRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for addCarveOutQuote without sending the request
     */
    async addCarveOutQuoteRequestOpts(requestParameters: AddCarveOutQuoteOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling addCarveOutQuote().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling addCarveOutQuote().'
            );
        }

        if (requestParameters['addCarveOutQuoteRequest'] == null) {
            throw new runtime.RequiredError(
                'addCarveOutQuoteRequest',
                'Required parameter "addCarveOutQuoteRequest" was null or undefined when calling addCarveOutQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}/quotes`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCarveOutQuoteRequestToJSON(requestParameters['addCarveOutQuoteRequest']),
        };
    }

    /**
     * Attach an uploaded pharmacy quote file to a carve-out
     */
    async addCarveOutQuoteRaw(requestParameters: AddCarveOutQuoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddCarveOutQuote201Response>> {
        const requestOptions = await this.addCarveOutQuoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddCarveOutQuote201ResponseFromJSON(jsonValue));
    }

    /**
     * Attach an uploaded pharmacy quote file to a carve-out
     */
    async addCarveOutQuote(requestParameters: AddCarveOutQuoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddCarveOutQuote201Response> {
        const response = await this.addCarveOutQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addDocumentToPalAuthSubmission without sending the request
     */
    async addDocumentToPalAuthSubmissionRequestOpts(requestParameters: AddDocumentToPalAuthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling addDocumentToPalAuthSubmission().'
            );
        }

        if (requestParameters['addDocumentToPalAuthSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'addDocumentToPalAuthSubmissionRequest',
                'Required parameter "addDocumentToPalAuthSubmissionRequest" was null or undefined when calling addDocumentToPalAuthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/documents-to-submit`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDocumentToPalAuthSubmissionRequestToJSON(requestParameters['addDocumentToPalAuthSubmissionRequest']),
        };
    }

    /**
     * Add documents to submit to a PAL auth submission
     */
    async addDocumentToPalAuthSubmissionRaw(requestParameters: AddDocumentToPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDocumentToPalAuthSubmission201Response>> {
        const requestOptions = await this.addDocumentToPalAuthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDocumentToPalAuthSubmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Add documents to submit to a PAL auth submission
     */
    async addDocumentToPalAuthSubmission(requestParameters: AddDocumentToPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDocumentToPalAuthSubmission201Response> {
        const response = await this.addDocumentToPalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for autosavePalAuthSubmission without sending the request
     */
    async autosavePalAuthSubmissionRequestOpts(requestParameters: AutosavePalAuthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling autosavePalAuthSubmission().'
            );
        }

        if (requestParameters['autosavePalAuthSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'autosavePalAuthSubmissionRequest',
                'Required parameter "autosavePalAuthSubmissionRequest" was null or undefined when calling autosavePalAuthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/autosave`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AutosavePalAuthSubmissionRequestToJSON(requestParameters['autosavePalAuthSubmissionRequest']),
        };
    }

    /**
     * Autosave a PAL auth submission\'s in-progress form draft
     */
    async autosavePalAuthSubmissionRaw(requestParameters: AutosavePalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutosavePalAuthSubmission200Response>> {
        const requestOptions = await this.autosavePalAuthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutosavePalAuthSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Autosave a PAL auth submission\'s in-progress form draft
     */
    async autosavePalAuthSubmission(requestParameters: AutosavePalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutosavePalAuthSubmission200Response> {
        const response = await this.autosavePalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cancelCarveOut without sending the request
     */
    async cancelCarveOutRequestOpts(requestParameters: CancelCarveOutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling cancelCarveOut().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling cancelCarveOut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}/cancel`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CarveOutTransitionRequestToJSON(requestParameters['carveOutTransitionRequest']),
        };
    }

    /**
     * Cancel a carve-out medication record
     */
    async cancelCarveOutRaw(requestParameters: CancelCarveOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCarveOut201Response>> {
        const requestOptions = await this.cancelCarveOutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCarveOut201ResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a carve-out medication record
     */
    async cancelCarveOut(requestParameters: CancelCarveOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCarveOut201Response> {
        const response = await this.cancelCarveOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCarveOut without sending the request
     */
    async createCarveOutRequestOpts(requestParameters: CreateCarveOutOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling createCarveOut().'
            );
        }

        if (requestParameters['createCarveOutRequest'] == null) {
            throw new runtime.RequiredError(
                'createCarveOutRequest',
                'Required parameter "createCarveOutRequest" was null or undefined when calling createCarveOut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCarveOutRequestToJSON(requestParameters['createCarveOutRequest']),
        };
    }

    /**
     * Create a manual carve-out medication record
     */
    async createCarveOutRaw(requestParameters: CreateCarveOutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCarveOut201Response>> {
        const requestOptions = await this.createCarveOutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCarveOut201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a manual carve-out medication record
     */
    async createCarveOut(requestParameters: CreateCarveOutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCarveOut201Response> {
        const response = await this.createCarveOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPalReauthCaseManager without sending the request
     */
    async createPalReauthCaseManagerRequestOpts(requestParameters: CreatePalReauthCaseManagerOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createPalReauthCaseManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'createPalReauthCaseManagerRequest',
                'Required parameter "createPalReauthCaseManagerRequest" was null or undefined when calling createPalReauthCaseManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-reauth-case-managers`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePalReauthCaseManagerRequestToJSON(requestParameters['createPalReauthCaseManagerRequest']),
        };
    }

    /**
     * Create a new case manager
     */
    async createPalReauthCaseManagerRaw(requestParameters: CreatePalReauthCaseManagerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthCaseManager201Response>> {
        const requestOptions = await this.createPalReauthCaseManagerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthCaseManager201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new case manager
     */
    async createPalReauthCaseManager(requestParameters: CreatePalReauthCaseManagerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthCaseManager201Response> {
        const response = await this.createPalReauthCaseManagerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPalReauthReportGeneration without sending the request
     */
    async createPalReauthReportGenerationRequestOpts(requestParameters: CreatePalReauthReportGenerationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createPalReauthReportGeneration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-submissions/{id}/report-generations`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Trigger a new PAL reauth report generation for a submission (or return the currently active one)
     */
    async createPalReauthReportGenerationRaw(requestParameters: CreatePalReauthReportGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthReportGeneration201Response>> {
        const requestOptions = await this.createPalReauthReportGenerationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthReportGeneration201ResponseFromJSON(jsonValue));
    }

    /**
     * Trigger a new PAL reauth report generation for a submission (or return the currently active one)
     */
    async createPalReauthReportGeneration(requestParameters: CreatePalReauthReportGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthReportGeneration201Response> {
        const response = await this.createPalReauthReportGenerationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPalReauthSubmission without sending the request
     */
    async createPalReauthSubmissionRequestOpts(requestParameters: CreatePalReauthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createPalReauthSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'createPalReauthSubmissionRequest',
                'Required parameter "createPalReauthSubmissionRequest" was null or undefined when calling createPalReauthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-reauth-submissions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePalReauthSubmissionRequestToJSON(requestParameters['createPalReauthSubmissionRequest']),
        };
    }

    /**
     * Create a new re-auth cycle
     */
    async createPalReauthSubmissionRaw(requestParameters: CreatePalReauthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthSubmission201Response>> {
        const requestOptions = await this.createPalReauthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthSubmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new re-auth cycle
     */
    async createPalReauthSubmission(requestParameters: CreatePalReauthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthSubmission201Response> {
        const response = await this.createPalReauthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPalSubmission without sending the request
     */
    async createPalSubmissionRequestOpts(requestParameters: CreatePalSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createPalSubmission().'
            );
        }

        if (requestParameters['createPalSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'createPalSubmissionRequest',
                'Required parameter "createPalSubmissionRequest" was null or undefined when calling createPalSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-leads/{lead_id}/pal-submission`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePalSubmissionRequestToJSON(requestParameters['createPalSubmissionRequest']),
        };
    }

    /**
     * Create PAL submission for a lead
     */
    async createPalSubmissionRaw(requestParameters: CreatePalSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.createPalSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Create PAL submission for a lead
     */
    async createPalSubmission(requestParameters: CreatePalSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.createPalSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPayerContracts without sending the request
     */
    async createPayerContractsRequestOpts(requestParameters: CreatePayerContractsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContract'] == null) {
            throw new runtime.RequiredError(
                'payerContract',
                'Required parameter "payerContract" was null or undefined when calling createPayerContracts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/payer-contracts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayerContractToJSON(requestParameters['payerContract']),
        };
    }

    /**
     * Create payer contract for a facility
     */
    async createPayerContractsRaw(requestParameters: CreatePayerContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePayerContracts201Response>> {
        const requestOptions = await this.createPayerContractsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePayerContracts201ResponseFromJSON(jsonValue));
    }

    /**
     * Create payer contract for a facility
     */
    async createPayerContracts(requestParameters: CreatePayerContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePayerContracts201Response> {
        const response = await this.createPayerContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createTimExecution without sending the request
     */
    async createTimExecutionRequestOpts(requestParameters: CreateTimExecutionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createTimExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/tim/execution`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Create TIM execution for a lead
     */
    async createTimExecutionRaw(requestParameters: CreateTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTimExecution200Response>> {
        const requestOptions = await this.createTimExecutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTimExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Create TIM execution for a lead
     */
    async createTimExecution(requestParameters: CreateTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTimExecution200Response> {
        const response = await this.createTimExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deferCarveOutToManual without sending the request
     */
    async deferCarveOutToManualRequestOpts(requestParameters: DeferCarveOutToManualRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling deferCarveOutToManual().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling deferCarveOutToManual().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}/defer-to-manual`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CarveOutTransitionRequestToJSON(requestParameters['carveOutTransitionRequest']),
        };
    }

    /**
     * Move a carve-out to Needs Manual Submission
     */
    async deferCarveOutToManualRaw(requestParameters: DeferCarveOutToManualRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCarveOut201Response>> {
        const requestOptions = await this.deferCarveOutToManualRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCarveOut201ResponseFromJSON(jsonValue));
    }

    /**
     * Move a carve-out to Needs Manual Submission
     */
    async deferCarveOutToManual(requestParameters: DeferCarveOutToManualRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCarveOut201Response> {
        const response = await this.deferCarveOutToManualRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteCarveOut without sending the request
     */
    async deleteCarveOutRequestOpts(requestParameters: DeleteCarveOutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling deleteCarveOut().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling deleteCarveOut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Soft-delete a carve-out medication record
     */
    async deleteCarveOutRaw(requestParameters: DeleteCarveOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCarveOutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-delete a carve-out medication record
     */
    async deleteCarveOut(requestParameters: DeleteCarveOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCarveOutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteCarveOutQuote without sending the request
     */
    async deleteCarveOutQuoteRequestOpts(requestParameters: DeleteCarveOutQuoteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling deleteCarveOutQuote().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling deleteCarveOutQuote().'
            );
        }

        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling deleteCarveOutQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}/quotes/{quote_id}`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));
        urlPath = urlPath.replace('{quote_id}', encodeURIComponent(String(requestParameters['quoteId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove a pharmacy quote file from a carve-out
     */
    async deleteCarveOutQuoteRaw(requestParameters: DeleteCarveOutQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCarveOutQuoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a pharmacy quote file from a carve-out
     */
    async deleteCarveOutQuote(requestParameters: DeleteCarveOutQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCarveOutQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteDocumentFromPalAuthSubmission without sending the request
     */
    async deleteDocumentFromPalAuthSubmissionRequestOpts(requestParameters: DeleteDocumentFromPalAuthSubmissionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling deleteDocumentFromPalAuthSubmission().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteDocumentFromPalAuthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/documents-to-submit/{document_id}`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{document_id}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a document from the list of documents to submit to a PAL auth submission
     */
    async deleteDocumentFromPalAuthSubmissionRaw(requestParameters: DeleteDocumentFromPalAuthSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteDocumentFromPalAuthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a document from the list of documents to submit to a PAL auth submission
     */
    async deleteDocumentFromPalAuthSubmission(requestParameters: DeleteDocumentFromPalAuthSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentFromPalAuthSubmissionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteEligibilityCheckById without sending the request
     */
    async deleteEligibilityCheckByIdRequestOpts(requestParameters: DeleteEligibilityCheckByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling deleteEligibilityCheckById().'
            );
        }

        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling deleteEligibilityCheckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/eligibility-checks/{check_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{check_id}', encodeURIComponent(String(requestParameters['checkId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete eligibility check by ID
     */
    async deleteEligibilityCheckByIdRaw(requestParameters: DeleteEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteEligibilityCheckByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete eligibility check by ID
     */
    async deleteEligibilityCheckById(requestParameters: DeleteEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEligibilityCheckByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteEnabledPayer without sending the request
     */
    async deleteEnabledPayerRequestOpts(requestParameters: DeleteEnabledPayerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerId'] == null) {
            throw new runtime.RequiredError(
                'payerId',
                'Required parameter "payerId" was null or undefined when calling deleteEnabledPayer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enabled-payers/{payer_id}`;
        urlPath = urlPath.replace('{payer_id}', encodeURIComponent(String(requestParameters['payerId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete enabled payer
     */
    async deleteEnabledPayerRaw(requestParameters: DeleteEnabledPayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteEnabledPayerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete enabled payer
     */
    async deleteEnabledPayer(requestParameters: DeleteEnabledPayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEnabledPayerRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deletePalReauthCaseManager without sending the request
     */
    async deletePalReauthCaseManagerRequestOpts(requestParameters: DeletePalReauthCaseManagerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePalReauthCaseManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-case-managers/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a case manager
     */
    async deletePalReauthCaseManagerRaw(requestParameters: DeletePalReauthCaseManagerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePalReauthCaseManagerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a case manager
     */
    async deletePalReauthCaseManager(requestParameters: DeletePalReauthCaseManagerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePalReauthCaseManagerRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deletePayerContractById without sending the request
     */
    async deletePayerContractByIdRequestOpts(requestParameters: DeletePayerContractByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContractId'] == null) {
            throw new runtime.RequiredError(
                'payerContractId',
                'Required parameter "payerContractId" was null or undefined when calling deletePayerContractById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payer-contracts/{payer_contract_id}`;
        urlPath = urlPath.replace('{payer_contract_id}', encodeURIComponent(String(requestParameters['payerContractId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete payer contract by id
     */
    async deletePayerContractByIdRaw(requestParameters: DeletePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePayerContractByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete payer contract by id
     */
    async deletePayerContractById(requestParameters: DeletePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePayerContractByIdRaw(requestParameters, initOverrides);
    }

    /**
    /**
     * Creates request options for findAllCarveOutTracking without sending the request
     */
    async findAllCarveOutTrackingRequestOpts(requestParameters: FindAllCarveOutTrackingRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        if (requestParameters['includeEmptyAdmission'] != null) {
            queryParameters['include_empty_admission'] = requestParameters['includeEmptyAdmission'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['authPlatformIds'] != null) {
            queryParameters['auth_platform_ids'] = requestParameters['authPlatformIds'];
        }

        if (requestParameters['includeManual'] != null) {
            queryParameters['include_manual'] = requestParameters['includeManual'];
        }

        if (requestParameters['includeHospital'] != null) {
            queryParameters['include_hospital'] = requestParameters['includeHospital'];
        }

        if (requestParameters['includeEfax'] != null) {
            queryParameters['include_efax'] = requestParameters['includeEfax'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        if (requestParameters['carveOutStatus'] != null) {
            queryParameters['carve_out_status'] = requestParameters['carveOutStatus'];
        }

        if (requestParameters['preset'] != null) {
            queryParameters['preset'] = requestParameters['preset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/carve-out-tracking`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * One row per PAL submission that has at least one non-deleted carve-out. Each row's Authorization Status is not rolled up server-side; the medications array carries each carve-out's own (trimmed) status and completeness so the client can render per-medication.
     * Find all carve-out tracking rows (Carve-Outs tab list)
     */
    async findAllCarveOutTrackingRaw(requestParameters: FindAllCarveOutTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCarveOutTracking200Response>> {
        const requestOptions = await this.findAllCarveOutTrackingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCarveOutTracking200ResponseFromJSON(jsonValue));
    }

    /**
     * One row per PAL submission that has at least one non-deleted carve-out. Each row's Authorization Status is not rolled up server-side; the medications array carries each carve-out's own (trimmed) status and completeness so the client can render per-medication.
     * Find all carve-out tracking rows (Carve-Outs tab list)
     */
    async findAllCarveOutTracking(requestParameters: FindAllCarveOutTrackingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCarveOutTracking200Response> {
        const response = await this.findAllCarveOutTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findCarveOutTrackingPresetCounts without sending the request
     */
    async findCarveOutTrackingPresetCountsRequestOpts(requestParameters: FindCarveOutTrackingPresetCountsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['includeEmptyAdmission'] != null) {
            queryParameters['include_empty_admission'] = requestParameters['includeEmptyAdmission'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['authPlatformIds'] != null) {
            queryParameters['auth_platform_ids'] = requestParameters['authPlatformIds'];
        }

        if (requestParameters['includeManual'] != null) {
            queryParameters['include_manual'] = requestParameters['includeManual'];
        }

        if (requestParameters['includeHospital'] != null) {
            queryParameters['include_hospital'] = requestParameters['includeHospital'];
        }

        if (requestParameters['includeEfax'] != null) {
            queryParameters['include_efax'] = requestParameters['includeEfax'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/carve-out-tracking/preset-counts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns per-preset counts of carve-out tracking rows (Not Submitted / In Review / Following), computed with the same preset mapping as FindAllCarveOutTracking over the same orthogonal filters, without the carve_out_status / preset / pagination / sort constraints.
     * Get Carve-Outs tab preset count badges
     */
    async findCarveOutTrackingPresetCountsRaw(requestParameters: FindCarveOutTrackingPresetCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindCarveOutTrackingPresetCounts200Response>> {
        const requestOptions = await this.findCarveOutTrackingPresetCountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindCarveOutTrackingPresetCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns per-preset counts of carve-out tracking rows (Not Submitted / In Review / Following), computed with the same preset mapping as FindAllCarveOutTracking over the same orthogonal filters, without the carve_out_status / preset / pagination / sort constraints.
     * Get Carve-Outs tab preset count badges
     */
    async findCarveOutTrackingPresetCounts(requestParameters: FindCarveOutTrackingPresetCountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindCarveOutTrackingPresetCounts200Response> {
        const response = await this.findCarveOutTrackingPresetCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllCarveOuts without sending the request
     */
    async findAllCarveOutsRequestOpts(requestParameters: FindAllCarveOutsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling findAllCarveOuts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List carve-out medications for a PAL auth submission
     */
    async findAllCarveOutsRaw(requestParameters: FindAllCarveOutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCarveOuts200Response>> {
        const requestOptions = await this.findAllCarveOutsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCarveOuts200ResponseFromJSON(jsonValue));
    }

    /**
     * List carve-out medications for a PAL auth submission
     */
    async findAllCarveOuts(requestParameters: FindAllCarveOutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCarveOuts200Response> {
        const response = await this.findAllCarveOutsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllPalAuthIntegrationsForLead without sending the request
     */
    async findAllPalAuthIntegrationsForLeadRequestOpts(requestParameters: FindAllPalAuthIntegrationsForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllPalAuthIntegrationsForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/pal-authorizations/integrations`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all PAL auth integrations enabled for a lead
     */
    async findAllPalAuthIntegrationsForLeadRaw(requestParameters: FindAllPalAuthIntegrationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalAuthIntegrationsForLead200Response>> {
        const requestOptions = await this.findAllPalAuthIntegrationsForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalAuthIntegrationsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all PAL auth integrations enabled for a lead
     */
    async findAllPalAuthIntegrationsForLead(requestParameters: FindAllPalAuthIntegrationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalAuthIntegrationsForLead200Response> {
        const response = await this.findAllPalAuthIntegrationsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllPalAuthPlatforms without sending the request
     */
    async findAllPalAuthPlatformsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-platforms`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all PAL auth platforms
     */
    async findAllPalAuthPlatformsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalAuthPlatforms200Response>> {
        const requestOptions = await this.findAllPalAuthPlatformsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalAuthPlatforms200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all PAL auth platforms
     */
    async findAllPalAuthPlatforms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalAuthPlatforms200Response> {
        const response = await this.findAllPalAuthPlatformsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllPalReauthCaseManagers without sending the request
     */
    async findAllPalReauthCaseManagersRequestOpts(requestParameters: FindAllPalReauthCaseManagersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-case-managers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all case managers with pagination and search
     */
    async findAllPalReauthCaseManagersRaw(requestParameters: FindAllPalReauthCaseManagersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalReauthCaseManagers200Response>> {
        const requestOptions = await this.findAllPalReauthCaseManagersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalReauthCaseManagers200ResponseFromJSON(jsonValue));
    }

    /**
     * List all case managers with pagination and search
     */
    async findAllPalReauthCaseManagers(requestParameters: FindAllPalReauthCaseManagersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalReauthCaseManagers200Response> {
        const response = await this.findAllPalReauthCaseManagersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllPalReauthSubmissions without sending the request
     */
    async findAllPalReauthSubmissionsRequestOpts(requestParameters: FindAllPalReauthSubmissionsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['timingState'] != null) {
            queryParameters['timing_state'] = requestParameters['timingState'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        if (requestParameters['preset'] != null) {
            queryParameters['preset'] = requestParameters['preset'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-submissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all re-auth cycles with pagination and filters
     */
    async findAllPalReauthSubmissionsRaw(requestParameters: FindAllPalReauthSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalReauthSubmissions200Response>> {
        const requestOptions = await this.findAllPalReauthSubmissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalReauthSubmissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all re-auth cycles with pagination and filters
     */
    async findAllPalReauthSubmissions(requestParameters: FindAllPalReauthSubmissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalReauthSubmissions200Response> {
        const response = await this.findAllPalReauthSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllPalSubmissions without sending the request
     */
    async findAllPalSubmissionsRequestOpts(requestParameters: FindAllPalSubmissionsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['submissionStatus'] != null) {
            queryParameters['submission_status'] = requestParameters['submissionStatus'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        if (requestParameters['includeEmptyAdmission'] != null) {
            queryParameters['include_empty_admission'] = requestParameters['includeEmptyAdmission'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['authPlatformIds'] != null) {
            queryParameters['auth_platform_ids'] = requestParameters['authPlatformIds'];
        }

        if (requestParameters['includeManual'] != null) {
            queryParameters['include_manual'] = requestParameters['includeManual'];
        }

        if (requestParameters['includeHospital'] != null) {
            queryParameters['include_hospital'] = requestParameters['includeHospital'];
        }

        if (requestParameters['includeEfax'] != null) {
            queryParameters['include_efax'] = requestParameters['includeEfax'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        if (requestParameters['preset'] != null) {
            queryParameters['preset'] = requestParameters['preset'];
        }

        if (requestParameters['benefitsVerified'] != null) {
            queryParameters['benefits_verified'] = requestParameters['benefitsVerified'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-submissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all PAL submissions with pagination
     */
    async findAllPalSubmissionsRaw(requestParameters: FindAllPalSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalSubmissions200Response>> {
        const requestOptions = await this.findAllPalSubmissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalSubmissions200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all PAL submissions with pagination
     */
    async findAllPalSubmissions(requestParameters: FindAllPalSubmissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalSubmissions200Response> {
        const response = await this.findAllPalSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOnePalInfo without sending the request
     */
    async findOnePalInfoRequestOpts(requestParameters: FindOnePalInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOnePalInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/pal-info`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find PAL information for a lead
     */
    async findOnePalInfoRaw(requestParameters: FindOnePalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePalInfo200Response>> {
        const requestOptions = await this.findOnePalInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePalInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * Find PAL information for a lead
     */
    async findOnePalInfo(requestParameters: FindOnePalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePalInfo200Response> {
        const response = await this.findOnePalInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findPalReauthCaseManagerById without sending the request
     */
    async findPalReauthCaseManagerByIdRequestOpts(requestParameters: FindPalReauthCaseManagerByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findPalReauthCaseManagerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-case-managers/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a case manager by ID
     */
    async findPalReauthCaseManagerByIdRaw(requestParameters: FindPalReauthCaseManagerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthCaseManager201Response>> {
        const requestOptions = await this.findPalReauthCaseManagerByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthCaseManager201ResponseFromJSON(jsonValue));
    }

    /**
     * Get a case manager by ID
     */
    async findPalReauthCaseManagerById(requestParameters: FindPalReauthCaseManagerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthCaseManager201Response> {
        const response = await this.findPalReauthCaseManagerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findPalReauthSubmissionById without sending the request
     */
    async findPalReauthSubmissionByIdRequestOpts(requestParameters: FindPalReauthSubmissionByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findPalReauthSubmissionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-submissions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a single re-auth by ID
     */
    async findPalReauthSubmissionByIdRaw(requestParameters: FindPalReauthSubmissionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthSubmission201Response>> {
        const requestOptions = await this.findPalReauthSubmissionByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthSubmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Get a single re-auth by ID
     */
    async findPalReauthSubmissionById(requestParameters: FindPalReauthSubmissionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthSubmission201Response> {
        const response = await this.findPalReauthSubmissionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findPalReauthSubmissionPresetCounts without sending the request
     */
    async findPalReauthSubmissionPresetCountsRequestOpts(requestParameters: FindPalReauthSubmissionPresetCountsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-submissions/preset-counts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns per-preset re-auth submission counts for the Concurrent Reviews preset bar (Not Submitted / In Review / Following). Computed with the same authoritative preset mapping as FindAllPalReauthSubmissions (including the denied-by-admission split) over the same orthogonal filters, but without the status / timing_state / preset / pagination / sort constraints.
     * Get Concurrent Review preset count badges
     */
    async findPalReauthSubmissionPresetCountsRaw(requestParameters: FindPalReauthSubmissionPresetCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindPalSubmissionPresetCounts200Response>> {
        const requestOptions = await this.findPalReauthSubmissionPresetCountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindPalSubmissionPresetCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns per-preset re-auth submission counts for the Concurrent Reviews preset bar (Not Submitted / In Review / Following). Computed with the same authoritative preset mapping as FindAllPalReauthSubmissions (including the denied-by-admission split) over the same orthogonal filters, but without the status / timing_state / preset / pagination / sort constraints.
     * Get Concurrent Review preset count badges
     */
    async findPalReauthSubmissionPresetCounts(requestParameters: FindPalReauthSubmissionPresetCountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindPalSubmissionPresetCounts200Response> {
        const response = await this.findPalReauthSubmissionPresetCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findPalSubmissionPresetCounts without sending the request
     */
    async findPalSubmissionPresetCountsRequestOpts(requestParameters: FindPalSubmissionPresetCountsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['includeEmptyAdmission'] != null) {
            queryParameters['include_empty_admission'] = requestParameters['includeEmptyAdmission'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['authPlatformIds'] != null) {
            queryParameters['auth_platform_ids'] = requestParameters['authPlatformIds'];
        }

        if (requestParameters['includeManual'] != null) {
            queryParameters['include_manual'] = requestParameters['includeManual'];
        }

        if (requestParameters['includeHospital'] != null) {
            queryParameters['include_hospital'] = requestParameters['includeHospital'];
        }

        if (requestParameters['includeEfax'] != null) {
            queryParameters['include_efax'] = requestParameters['includeEfax'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-submissions/preset-counts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns per-preset submission counts for the Prior Authorizations preset bar (Not Submitted / In Review / Following). Computed with the same authoritative preset mapping as FindAllPalSubmissions (including the denied-by-admission split) over the same orthogonal filters, but without the submission_status / preset / pagination / sort constraints.
     * Get Prior Authorization preset count badges
     */
    async findPalSubmissionPresetCountsRaw(requestParameters: FindPalSubmissionPresetCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindPalSubmissionPresetCounts200Response>> {
        const requestOptions = await this.findPalSubmissionPresetCountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindPalSubmissionPresetCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns per-preset submission counts for the Prior Authorizations preset bar (Not Submitted / In Review / Following). Computed with the same authoritative preset mapping as FindAllPalSubmissions (including the denied-by-admission split) over the same orthogonal filters, but without the submission_status / preset / pagination / sort constraints.
     * Get Prior Authorization preset count badges
     */
    async findPalSubmissionPresetCounts(requestParameters: FindPalSubmissionPresetCountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindPalSubmissionPresetCounts200Response> {
        const response = await this.findPalSubmissionPresetCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateEligibilityCheckReport without sending the request
     */
    async generateEligibilityCheckReportRequestOpts(requestParameters: GenerateEligibilityCheckReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling generateEligibilityCheckReport().'
            );
        }

        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling generateEligibilityCheckReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/eligibility-checks/{check_id}/report`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{check_id}', encodeURIComponent(String(requestParameters['checkId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generate eligibility check report for a lead
     */
    async generateEligibilityCheckReportRaw(requestParameters: GenerateEligibilityCheckReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateEligibilityCheckReport200Response>> {
        const requestOptions = await this.generateEligibilityCheckReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateEligibilityCheckReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate eligibility check report for a lead
     */
    async generateEligibilityCheckReport(requestParameters: GenerateEligibilityCheckReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateEligibilityCheckReport200Response> {
        const response = await this.generateEligibilityCheckReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEligibilityCheckById without sending the request
     */
    async getEligibilityCheckByIdRequestOpts(requestParameters: GetEligibilityCheckByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getEligibilityCheckById().'
            );
        }

        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError(
                'checkId',
                'Required parameter "checkId" was null or undefined when calling getEligibilityCheckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/eligibility-checks/{check_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{check_id}', encodeURIComponent(String(requestParameters['checkId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get eligibility check by ID
     */
    async getEligibilityCheckByIdRaw(requestParameters: GetEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PerformEligibilityCheck200Response>> {
        const requestOptions = await this.getEligibilityCheckByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformEligibilityCheck200ResponseFromJSON(jsonValue));
    }

    /**
     * Get eligibility check by ID
     */
    async getEligibilityCheckById(requestParameters: GetEligibilityCheckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PerformEligibilityCheck200Response> {
        const response = await this.getEligibilityCheckByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEligibilityChecks without sending the request
     */
    async getEligibilityChecksRequestOpts(requestParameters: GetEligibilityChecksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getEligibilityChecks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/eligibility-checks`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get eligibility checks for a lead
     */
    async getEligibilityChecksRaw(requestParameters: GetEligibilityChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEligibilityChecks200Response>> {
        const requestOptions = await this.getEligibilityChecksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEligibilityChecks200ResponseFromJSON(jsonValue));
    }

    /**
     * Get eligibility checks for a lead
     */
    async getEligibilityChecks(requestParameters: GetEligibilityChecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEligibilityChecks200Response> {
        const response = await this.getEligibilityChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEnabledPayers without sending the request
     */
    async getEnabledPayersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enabled-payers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get payers enabled for the current organization
     */
    async getEnabledPayersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEnabledPayers200Response>> {
        const requestOptions = await this.getEnabledPayersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEnabledPayers200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payers enabled for the current organization
     */
    async getEnabledPayers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEnabledPayers200Response> {
        const response = await this.getEnabledPayersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getExaCarePayerList without sending the request
     */
    async getExaCarePayerListRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payers/exacare`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get ExaCare payer list
     */
    async getExaCarePayerListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExaCarePayerList200Response>> {
        const requestOptions = await this.getExaCarePayerListRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExaCarePayerList200ResponseFromJSON(jsonValue));
    }

    /**
     * Get ExaCare payer list
     */
    async getExaCarePayerList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExaCarePayerList200Response> {
        const response = await this.getExaCarePayerListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getInovalonPayerList without sending the request
     */
    async getInovalonPayerListRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payers/inovalon`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all inovalon payers
     */
    async getInovalonPayerListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInovalonPayerList200Response>> {
        const requestOptions = await this.getInovalonPayerListRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInovalonPayerList200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all inovalon payers
     */
    async getInovalonPayerList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInovalonPayerList200Response> {
        const response = await this.getInovalonPayerListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getInovalonPayerSearchOptions without sending the request
     */
    async getInovalonPayerSearchOptionsRequestOpts(requestParameters: GetInovalonPayerSearchOptionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerId'] == null) {
            throw new runtime.RequiredError(
                'payerId',
                'Required parameter "payerId" was null or undefined when calling getInovalonPayerSearchOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payers/inovalon/payer-search-options/{payer_id}`;
        urlPath = urlPath.replace('{payer_id}', encodeURIComponent(String(requestParameters['payerId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get payer search options for a payer
     */
    async getInovalonPayerSearchOptionsRaw(requestParameters: GetInovalonPayerSearchOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInovalonPayerSearchOptions200Response>> {
        const requestOptions = await this.getInovalonPayerSearchOptionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInovalonPayerSearchOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payer search options for a payer
     */
    async getInovalonPayerSearchOptions(requestParameters: GetInovalonPayerSearchOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInovalonPayerSearchOptions200Response> {
        const response = await this.getInovalonPayerSearchOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLatestPalReauthReportGeneration without sending the request
     */
    async getLatestPalReauthReportGenerationRequestOpts(requestParameters: GetLatestPalReauthReportGenerationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLatestPalReauthReportGeneration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-submissions/{id}/report-generations/latest`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the latest PAL reauth report generation for a submission
     */
    async getLatestPalReauthReportGenerationRaw(requestParameters: GetLatestPalReauthReportGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthReportGeneration201Response>> {
        const requestOptions = await this.getLatestPalReauthReportGenerationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthReportGeneration201ResponseFromJSON(jsonValue));
    }

    /**
     * Get the latest PAL reauth report generation for a submission
     */
    async getLatestPalReauthReportGeneration(requestParameters: GetLatestPalReauthReportGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthReportGeneration201Response> {
        const response = await this.getLatestPalReauthReportGenerationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLatestPalSubmission without sending the request
     */
    async getLatestPalSubmissionRequestOpts(requestParameters: GetLatestPalSubmissionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getLatestPalSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/pal-submission`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get latest PAL submission for a lead
     */
    async getLatestPalSubmissionRaw(requestParameters: GetLatestPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.getLatestPalSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Get latest PAL submission for a lead
     */
    async getLatestPalSubmission(requestParameters: GetLatestPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.getLatestPalSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLeadAssessmentForm without sending the request
     */
    async getLeadAssessmentFormRequestOpts(requestParameters: GetLeadAssessmentFormRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getLeadAssessmentForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/medicare-estimates/assessment`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Medicare Assessment Form for a lead
     */
    async getLeadAssessmentFormRaw(requestParameters: GetLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadAssessmentForm200Response>> {
        const requestOptions = await this.getLeadAssessmentFormRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadAssessmentForm200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare Assessment Form for a lead
     */
    async getLeadAssessmentForm(requestParameters: GetLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadAssessmentForm200Response> {
        const response = await this.getLeadAssessmentFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicareAssessmentFormOptions without sending the request
     */
    async getMedicareAssessmentFormOptionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicare/assessment-form-options`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Medicare Assessment Form Options
     */
    async getMedicareAssessmentFormOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicareAssessmentFormOptions200Response>> {
        const requestOptions = await this.getMedicareAssessmentFormOptionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicareAssessmentFormOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare Assessment Form Options
     */
    async getMedicareAssessmentFormOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicareAssessmentFormOptions200Response> {
        const response = await this.getMedicareAssessmentFormOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicareEstimates without sending the request
     */
    async getMedicareEstimatesRequestOpts(requestParameters: GetMedicareEstimatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMedicareEstimates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/medicare-estimates`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Medicare Reimbursment estimates for a lead
     */
    async getMedicareEstimatesRaw(requestParameters: GetMedicareEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicareEstimates200Response>> {
        const requestOptions = await this.getMedicareEstimatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicareEstimates200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare Reimbursment estimates for a lead
     */
    async getMedicareEstimates(requestParameters: GetMedicareEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicareEstimates200Response> {
        const response = await this.getMedicareEstimatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMedicarePtOtMappings without sending the request
     */
    async getMedicarePtOtMappingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/medicare/pt-ot-mappings`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Medicare PT/OT diagnoses/case-mix group mappings
     */
    async getMedicarePtOtMappingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicarePtOtMappings200Response>> {
        const requestOptions = await this.getMedicarePtOtMappingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicarePtOtMappings200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Medicare PT/OT diagnoses/case-mix group mappings
     */
    async getMedicarePtOtMappings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicarePtOtMappings200Response> {
        const response = await this.getMedicarePtOtMappingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPalReauthSubmissionHistory without sending the request
     */
    async getPalReauthSubmissionHistoryRequestOpts(requestParameters: GetPalReauthSubmissionHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getPalReauthSubmissionHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/pal-reauth-submission-history`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get complete auth history for a lead
     */
    async getPalReauthSubmissionHistoryRaw(requestParameters: GetPalReauthSubmissionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPalReauthSubmissionHistory200Response>> {
        const requestOptions = await this.getPalReauthSubmissionHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPalReauthSubmissionHistory200ResponseFromJSON(jsonValue));
    }

    /**
     * Get complete auth history for a lead
     */
    async getPalReauthSubmissionHistory(requestParameters: GetPalReauthSubmissionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPalReauthSubmissionHistory200Response> {
        const response = await this.getPalReauthSubmissionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayerContractById without sending the request
     */
    async getPayerContractByIdRequestOpts(requestParameters: GetPayerContractByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContractId'] == null) {
            throw new runtime.RequiredError(
                'payerContractId',
                'Required parameter "payerContractId" was null or undefined when calling getPayerContractById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payer-contracts/{payer_contract_id}`;
        urlPath = urlPath.replace('{payer_contract_id}', encodeURIComponent(String(requestParameters['payerContractId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get payer contract by id
     */
    async getPayerContractByIdRaw(requestParameters: GetPayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePayerContracts201Response>> {
        const requestOptions = await this.getPayerContractByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePayerContracts201ResponseFromJSON(jsonValue));
    }

    /**
     * Get payer contract by id
     */
    async getPayerContractById(requestParameters: GetPayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePayerContracts201Response> {
        const response = await this.getPayerContractByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayerContractRules without sending the request
     */
    async getPayerContractRulesRequestOpts(requestParameters: GetPayerContractRulesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContractId'] == null) {
            throw new runtime.RequiredError(
                'payerContractId',
                'Required parameter "payerContractId" was null or undefined when calling getPayerContractRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payer-contracts/{payer_contract_id}/rules`;
        urlPath = urlPath.replace('{payer_contract_id}', encodeURIComponent(String(requestParameters['payerContractId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get rules for a payer contract
     */
    async getPayerContractRulesRaw(requestParameters: GetPayerContractRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayerContractRules200Response>> {
        const requestOptions = await this.getPayerContractRulesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayerContractRules200ResponseFromJSON(jsonValue));
    }

    /**
     * Get rules for a payer contract
     */
    async getPayerContractRules(requestParameters: GetPayerContractRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayerContractRules200Response> {
        const response = await this.getPayerContractRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayerContractStructuredContract without sending the request
     */
    async getPayerContractStructuredContractRequestOpts(requestParameters: GetPayerContractStructuredContractRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContractId'] == null) {
            throw new runtime.RequiredError(
                'payerContractId',
                'Required parameter "payerContractId" was null or undefined when calling getPayerContractStructuredContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payer-contracts/{payer_contract_id}/structured-contract`;
        urlPath = urlPath.replace('{payer_contract_id}', encodeURIComponent(String(requestParameters['payerContractId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get structured contract data for a payer contract
     */
    async getPayerContractStructuredContractRaw(requestParameters: GetPayerContractStructuredContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayerContractStructuredContract200Response>> {
        const requestOptions = await this.getPayerContractStructuredContractRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayerContractStructuredContract200ResponseFromJSON(jsonValue));
    }

    /**
     * Get structured contract data for a payer contract
     */
    async getPayerContractStructuredContract(requestParameters: GetPayerContractStructuredContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayerContractStructuredContract200Response> {
        const response = await this.getPayerContractStructuredContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayerContracts without sending the request
     */
    async getPayerContractsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payer-contracts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get payer contracts for all facilities available for the current user
     */
    async getPayerContractsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayerContracts200Response>> {
        const requestOptions = await this.getPayerContractsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayerContracts200ResponseFromJSON(jsonValue));
    }

    /**
     * Get payer contracts for all facilities available for the current user
     */
    async getPayerContracts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayerContracts200Response> {
        const response = await this.getPayerContractsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStediPayers without sending the request
     */
    async getStediPayersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payers/stedi`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Stedi payers
     */
    async getStediPayersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStediPayers200Response>> {
        const requestOptions = await this.getStediPayersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStediPayers200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Stedi payers
     */
    async getStediPayers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStediPayers200Response> {
        const response = await this.getStediPayersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTimExecution without sending the request
     */
    async getTimExecutionRequestOpts(requestParameters: GetTimExecutionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getTimExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/tim/execution`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get TIM execution for a lead
     */
    async getTimExecutionRaw(requestParameters: GetTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTimExecution200Response>> {
        const requestOptions = await this.getTimExecutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTimExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Get TIM execution for a lead
     */
    async getTimExecution(requestParameters: GetTimExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTimExecution200Response> {
        const response = await this.getTimExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for markPalAuthSubmissionAsManual without sending the request
     */
    async markPalAuthSubmissionAsManualRequestOpts(requestParameters: MarkPalAuthSubmissionAsManualOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling markPalAuthSubmissionAsManual().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/mark-manual-submission`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkPalAuthSubmissionAsManualRequestToJSON(requestParameters['markPalAuthSubmissionAsManualRequest']),
        };
    }

    /**
     * Mark a failed PAL auth submission as manually submitted
     */
    async markPalAuthSubmissionAsManualRaw(requestParameters: MarkPalAuthSubmissionAsManualOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.markPalAuthSubmissionAsManualRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Mark a failed PAL auth submission as manually submitted
     */
    async markPalAuthSubmissionAsManual(requestParameters: MarkPalAuthSubmissionAsManualOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.markPalAuthSubmissionAsManualRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for markPayerAsInn without sending the request
     */
    async markPayerAsInnRequestOpts(requestParameters: MarkPayerAsInnOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerId'] == null) {
            throw new runtime.RequiredError(
                'payerId',
                'Required parameter "payerId" was null or undefined when calling markPayerAsInn().'
            );
        }

        if (requestParameters['markPayerAsInnRequest'] == null) {
            throw new runtime.RequiredError(
                'markPayerAsInnRequest',
                'Required parameter "markPayerAsInnRequest" was null or undefined when calling markPayerAsInn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/enabled-payers/{payer_id}/inn-facilities`;
        urlPath = urlPath.replace('{payer_id}', encodeURIComponent(String(requestParameters['payerId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkPayerAsInnRequestToJSON(requestParameters['markPayerAsInnRequest']),
        };
    }

    /**
     * Mark payer as INN for a facility
     */
    async markPayerAsInnRaw(requestParameters: MarkPayerAsInnOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.markPayerAsInnRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark payer as INN for a facility
     */
    async markPayerAsInn(requestParameters: MarkPayerAsInnOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markPayerAsInnRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for performEligibilityCheck without sending the request
     */
    async performEligibilityCheckRequestOpts(requestParameters: PerformEligibilityCheckOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling performEligibilityCheck().'
            );
        }

        if (requestParameters['performEligibilityCheckRequest'] == null) {
            throw new runtime.RequiredError(
                'performEligibilityCheckRequest',
                'Required parameter "performEligibilityCheckRequest" was null or undefined when calling performEligibilityCheck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-leads/{lead_id}/eligibility-checks`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PerformEligibilityCheckRequestToJSON(requestParameters['performEligibilityCheckRequest']),
        };
    }

    /**
     * Performs eligibility check for a lead
     */
    async performEligibilityCheckRaw(requestParameters: PerformEligibilityCheckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PerformEligibilityCheck200Response>> {
        const requestOptions = await this.performEligibilityCheckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformEligibilityCheck200ResponseFromJSON(jsonValue));
    }

    /**
     * Performs eligibility check for a lead
     */
    async performEligibilityCheck(requestParameters: PerformEligibilityCheckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PerformEligibilityCheck200Response> {
        const response = await this.performEligibilityCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for refreshPalAuthSubmissionLevelAssessment without sending the request
     */
    async refreshPalAuthSubmissionLevelAssessmentRequestOpts(requestParameters: RefreshPalAuthSubmissionLevelAssessmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling refreshPalAuthSubmissionLevelAssessment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/refresh-level-assessment`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Refresh level assessment for a submitted PAL auth submission
     */
    async refreshPalAuthSubmissionLevelAssessmentRaw(requestParameters: RefreshPalAuthSubmissionLevelAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.refreshPalAuthSubmissionLevelAssessmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Refresh level assessment for a submitted PAL auth submission
     */
    async refreshPalAuthSubmissionLevelAssessment(requestParameters: RefreshPalAuthSubmissionLevelAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.refreshPalAuthSubmissionLevelAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for restartPalSubmission without sending the request
     */
    async restartPalSubmissionRequestOpts(requestParameters: RestartPalSubmissionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling restartPalSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/restart`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Restart a PAL auth submission from scratch
     */
    async restartPalSubmissionRaw(requestParameters: RestartPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.restartPalSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Restart a PAL auth submission from scratch
     */
    async restartPalSubmission(requestParameters: RestartPalSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.restartPalSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for retryPalAuthWithMissingInput without sending the request
     */
    async retryPalAuthWithMissingInputRequestOpts(requestParameters: RetryPalAuthWithMissingInputOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling retryPalAuthWithMissingInput().'
            );
        }

        if (requestParameters['retryPalAuthWithMissingInputRequest'] == null) {
            throw new runtime.RequiredError(
                'retryPalAuthWithMissingInputRequest',
                'Required parameter "retryPalAuthWithMissingInputRequest" was null or undefined when calling retryPalAuthWithMissingInput().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/retry-with-missing-input`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetryPalAuthWithMissingInputRequestToJSON(requestParameters['retryPalAuthWithMissingInputRequest']),
        };
    }

    /**
     * Retry a failed PAL auth submission by providing missing input data
     */
    async retryPalAuthWithMissingInputRaw(requestParameters: RetryPalAuthWithMissingInputOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.retryPalAuthWithMissingInputRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Retry a failed PAL auth submission by providing missing input data
     */
    async retryPalAuthWithMissingInput(requestParameters: RetryPalAuthWithMissingInputOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.retryPalAuthWithMissingInputRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revertCarveOutStatus without sending the request
     */
    async revertCarveOutStatusRequestOpts(requestParameters: RevertCarveOutStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling revertCarveOutStatus().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling revertCarveOutStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}/status-revert`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revert a carve-out\'s status to its previous value
     */
    async revertCarveOutStatusRaw(requestParameters: RevertCarveOutStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCarveOut201Response>> {
        const requestOptions = await this.revertCarveOutStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCarveOut201ResponseFromJSON(jsonValue));
    }

    /**
     * Revert a carve-out\'s status to its previous value
     */
    async revertCarveOutStatus(requestParameters: RevertCarveOutStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCarveOut201Response> {
        const response = await this.revertCarveOutStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revertPalAuthSubmissionStatus without sending the request
     */
    async revertPalAuthSubmissionStatusRequestOpts(requestParameters: RevertPalAuthSubmissionStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling revertPalAuthSubmissionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/status-revert`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revert PAL auth submission status to previous one
     */
    async revertPalAuthSubmissionStatusRaw(requestParameters: RevertPalAuthSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.revertPalAuthSubmissionStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Revert PAL auth submission status to previous one
     */
    async revertPalAuthSubmissionStatus(requestParameters: RevertPalAuthSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.revertPalAuthSubmissionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revertPalReauthSubmissionStatus without sending the request
     */
    async revertPalReauthSubmissionStatusRequestOpts(requestParameters: RevertPalReauthSubmissionStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling revertPalReauthSubmissionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pal-reauth-submissions/{id}/revert`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revert re-auth status to previous state
     */
    async revertPalReauthSubmissionStatusRaw(requestParameters: RevertPalReauthSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthSubmission201Response>> {
        const requestOptions = await this.revertPalReauthSubmissionStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthSubmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Revert re-auth status to previous state
     */
    async revertPalReauthSubmissionStatus(requestParameters: RevertPalReauthSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthSubmission201Response> {
        const response = await this.revertPalReauthSubmissionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reviewPalAuthSubmission without sending the request
     */
    async reviewPalAuthSubmissionRequestOpts(requestParameters: ReviewPalAuthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling reviewPalAuthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/review`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReviewPalAuthSubmissionRequestToJSON(requestParameters['reviewPalAuthSubmissionRequest']),
        };
    }

    /**
     * Move PAL auth submission to review status
     */
    async reviewPalAuthSubmissionRaw(requestParameters: ReviewPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.reviewPalAuthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Move PAL auth submission to review status
     */
    async reviewPalAuthSubmission(requestParameters: ReviewPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.reviewPalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPalAuthPlatformRemotePatient without sending the request
     */
    async searchPalAuthPlatformRemotePatientRequestOpts(requestParameters: SearchPalAuthPlatformRemotePatientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling searchPalAuthPlatformRemotePatient().'
            );
        }

        if (requestParameters['authPlatformRemotePatientSearchPayload'] == null) {
            throw new runtime.RequiredError(
                'authPlatformRemotePatientSearchPayload',
                'Required parameter "authPlatformRemotePatientSearchPayload" was null or undefined when calling searchPalAuthPlatformRemotePatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/remote-patient-search`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthPlatformRemotePatientSearchPayloadToJSON(requestParameters['authPlatformRemotePatientSearchPayload']),
        };
    }

    /**
     * Search remote patient in the PAL auth platform
     */
    async searchPalAuthPlatformRemotePatientRaw(requestParameters: SearchPalAuthPlatformRemotePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPalAuthPlatformRemotePatient200Response>> {
        const requestOptions = await this.searchPalAuthPlatformRemotePatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPalAuthPlatformRemotePatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Search remote patient in the PAL auth platform
     */
    async searchPalAuthPlatformRemotePatient(requestParameters: SearchPalAuthPlatformRemotePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPalAuthPlatformRemotePatient200Response> {
        const response = await this.searchPalAuthPlatformRemotePatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setCarveOutSelection without sending the request
     */
    async setCarveOutSelectionRequestOpts(requestParameters: SetCarveOutSelectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling setCarveOutSelection().'
            );
        }

        if (requestParameters['carveOutSelectionRequest'] == null) {
            throw new runtime.RequiredError(
                'carveOutSelectionRequest',
                'Required parameter "carveOutSelectionRequest" was null or undefined when calling setCarveOutSelection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/selection`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CarveOutSelectionRequestToJSON(requestParameters['carveOutSelectionRequest']),
        };
    }

    /**
     * Persist the step-2 carve-out selection state for a submission
     */
    async setCarveOutSelectionRaw(requestParameters: SetCarveOutSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setCarveOutSelectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Persist the step-2 carve-out selection state for a submission
     */
    async setCarveOutSelection(requestParameters: SetCarveOutSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setCarveOutSelectionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for submitPalAuthSubmission without sending the request
     */
    async submitPalAuthSubmissionRequestOpts(requestParameters: SubmitPalAuthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling submitPalAuthSubmission().'
            );
        }

        if (requestParameters['submitPalAuthSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'submitPalAuthSubmissionRequest',
                'Required parameter "submitPalAuthSubmissionRequest" was null or undefined when calling submitPalAuthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/submit`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitPalAuthSubmissionRequestToJSON(requestParameters['submitPalAuthSubmissionRequest']),
        };
    }

    /**
     * Submit a PAL auth submission
     */
    async submitPalAuthSubmissionRaw(requestParameters: SubmitPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.submitPalAuthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Submit a PAL auth submission
     */
    async submitPalAuthSubmission(requestParameters: SubmitPalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.submitPalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unmarkPayerAsInn without sending the request
     */
    async unmarkPayerAsInnRequestOpts(requestParameters: UnmarkPayerAsInnRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerId'] == null) {
            throw new runtime.RequiredError(
                'payerId',
                'Required parameter "payerId" was null or undefined when calling unmarkPayerAsInn().'
            );
        }

        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling unmarkPayerAsInn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enabled-payers/{payer_id}/inn-facilities/{facility_id}`;
        urlPath = urlPath.replace('{payer_id}', encodeURIComponent(String(requestParameters['payerId'])));
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Unmark payer as INN for a facility
     */
    async unmarkPayerAsInnRaw(requestParameters: UnmarkPayerAsInnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.unmarkPayerAsInnRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unmark payer as INN for a facility
     */
    async unmarkPayerAsInn(requestParameters: UnmarkPayerAsInnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unmarkPayerAsInnRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for unmarkPayerTypeAsInn without sending the request
     */
    async unmarkPayerTypeAsInnRequestOpts(requestParameters: UnmarkPayerTypeAsInnRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerId'] == null) {
            throw new runtime.RequiredError(
                'payerId',
                'Required parameter "payerId" was null or undefined when calling unmarkPayerTypeAsInn().'
            );
        }

        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling unmarkPayerTypeAsInn().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling unmarkPayerTypeAsInn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enabled-payers/{payer_id}/inn-facilities/{facility_id}/types/{type}`;
        urlPath = urlPath.replace('{payer_id}', encodeURIComponent(String(requestParameters['payerId'])));
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));
        urlPath = urlPath.replace('{type}', encodeURIComponent(String(requestParameters['type'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Unmark a specific insurance type for a payer/facility as INN
     */
    async unmarkPayerTypeAsInnRaw(requestParameters: UnmarkPayerTypeAsInnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.unmarkPayerTypeAsInnRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unmark a specific insurance type for a payer/facility as INN
     */
    async unmarkPayerTypeAsInn(requestParameters: UnmarkPayerTypeAsInnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unmarkPayerTypeAsInnRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateCarveOut without sending the request
     */
    async updateCarveOutRequestOpts(requestParameters: UpdateCarveOutOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling updateCarveOut().'
            );
        }

        if (requestParameters['carveOutId'] == null) {
            throw new runtime.RequiredError(
                'carveOutId',
                'Required parameter "carveOutId" was null or undefined when calling updateCarveOut().'
            );
        }

        if (requestParameters['updateCarveOutRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCarveOutRequest',
                'Required parameter "updateCarveOutRequest" was null or undefined when calling updateCarveOut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}/carve-outs/{carve_out_id}`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));
        urlPath = urlPath.replace('{carve_out_id}', encodeURIComponent(String(requestParameters['carveOutId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCarveOutRequestToJSON(requestParameters['updateCarveOutRequest']),
        };
    }

    /**
     * Update a carve-out medication record
     */
    async updateCarveOutRaw(requestParameters: UpdateCarveOutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCarveOut201Response>> {
        const requestOptions = await this.updateCarveOutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCarveOut201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a carve-out medication record
     */
    async updateCarveOut(requestParameters: UpdateCarveOutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCarveOut201Response> {
        const response = await this.updateCarveOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateEnabledPayersBulk without sending the request
     */
    async updateEnabledPayersBulkRequestOpts(requestParameters: UpdateEnabledPayersBulkOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateEnabledPayersBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'updateEnabledPayersBulkRequest',
                'Required parameter "updateEnabledPayersBulkRequest" was null or undefined when calling updateEnabledPayersBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/enabled-payers/bulk`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEnabledPayersBulkRequestToJSON(requestParameters['updateEnabledPayersBulkRequest']),
        };
    }

    /**
     * Enable or disable payers for the current organization
     */
    async updateEnabledPayersBulkRaw(requestParameters: UpdateEnabledPayersBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateEnabledPayersBulkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enable or disable payers for the current organization
     */
    async updateEnabledPayersBulk(requestParameters: UpdateEnabledPayersBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEnabledPayersBulkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateLeadAssessmentForm without sending the request
     */
    async updateLeadAssessmentFormRequestOpts(requestParameters: UpdateLeadAssessmentFormRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateLeadAssessmentForm().'
            );
        }

        if (requestParameters['medicareAssessmentForm'] == null) {
            throw new runtime.RequiredError(
                'medicareAssessmentForm',
                'Required parameter "medicareAssessmentForm" was null or undefined when calling updateLeadAssessmentForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-leads/{lead_id}/medicare-estimates/assessment`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicareAssessmentFormToJSON(requestParameters['medicareAssessmentForm']),
        };
    }

    /**
     * Update Medicare Assessment Form for a lead
     */
    async updateLeadAssessmentFormRaw(requestParameters: UpdateLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadAssessmentForm200Response>> {
        const requestOptions = await this.updateLeadAssessmentFormRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadAssessmentForm200ResponseFromJSON(jsonValue));
    }

    /**
     * Update Medicare Assessment Form for a lead
     */
    async updateLeadAssessmentForm(requestParameters: UpdateLeadAssessmentFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadAssessmentForm200Response> {
        const response = await this.updateLeadAssessmentFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadInsurances without sending the request
     */
    async updateLeadInsurancesRequestOpts(requestParameters: UpdateLeadInsurancesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateLeadInsurances().'
            );
        }

        if (requestParameters['screenerInsurance'] == null) {
            throw new runtime.RequiredError(
                'screenerInsurance',
                'Required parameter "screenerInsurance" was null or undefined when calling updateLeadInsurances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-leads/{lead_id}/insurances`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['screenerInsurance']!.map(ScreenerInsuranceToJSON),
        };
    }

    /**
     * Update insurances for a lead
     */
    async updateLeadInsurancesRaw(requestParameters: UpdateLeadInsurancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadInsurances200Response>> {
        const requestOptions = await this.updateLeadInsurancesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadInsurances200ResponseFromJSON(jsonValue));
    }

    /**
     * Update insurances for a lead
     */
    async updateLeadInsurances(requestParameters: UpdateLeadInsurancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadInsurances200Response> {
        const response = await this.updateLeadInsurancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePalAuthSubmission without sending the request
     */
    async updatePalAuthSubmissionRequestOpts(requestParameters: UpdatePalAuthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['palAuthSubmissionId'] == null) {
            throw new runtime.RequiredError(
                'palAuthSubmissionId',
                'Required parameter "palAuthSubmissionId" was null or undefined when calling updatePalAuthSubmission().'
            );
        }

        if (requestParameters['updatePalAuthSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePalAuthSubmissionRequest',
                'Required parameter "updatePalAuthSubmissionRequest" was null or undefined when calling updatePalAuthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-auth-submissions/{pal_auth_submission_id}`;
        urlPath = urlPath.replace('{pal_auth_submission_id}', encodeURIComponent(String(requestParameters['palAuthSubmissionId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePalAuthSubmissionRequestToJSON(requestParameters['updatePalAuthSubmissionRequest']),
        };
    }

    /**
     * Update a PAL auth submission
     */
    async updatePalAuthSubmissionRaw(requestParameters: UpdatePalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLatestPalSubmission200Response>> {
        const requestOptions = await this.updatePalAuthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLatestPalSubmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a PAL auth submission
     */
    async updatePalAuthSubmission(requestParameters: UpdatePalAuthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLatestPalSubmission200Response> {
        const response = await this.updatePalAuthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePalReauthCaseManager without sending the request
     */
    async updatePalReauthCaseManagerRequestOpts(requestParameters: UpdatePalReauthCaseManagerOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePalReauthCaseManager().'
            );
        }

        if (requestParameters['updatePalReauthCaseManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePalReauthCaseManagerRequest',
                'Required parameter "updatePalReauthCaseManagerRequest" was null or undefined when calling updatePalReauthCaseManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-reauth-case-managers/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePalReauthCaseManagerRequestToJSON(requestParameters['updatePalReauthCaseManagerRequest']),
        };
    }

    /**
     * Update a case manager
     */
    async updatePalReauthCaseManagerRaw(requestParameters: UpdatePalReauthCaseManagerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthCaseManager201Response>> {
        const requestOptions = await this.updatePalReauthCaseManagerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthCaseManager201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a case manager
     */
    async updatePalReauthCaseManager(requestParameters: UpdatePalReauthCaseManagerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthCaseManager201Response> {
        const response = await this.updatePalReauthCaseManagerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePalReauthEmrDocumentSelection without sending the request
     */
    async updatePalReauthEmrDocumentSelectionRequestOpts(requestParameters: UpdatePalReauthEmrDocumentSelectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePalReauthEmrDocumentSelection().'
            );
        }

        if (requestParameters['externalEmrDocumentId'] == null) {
            throw new runtime.RequiredError(
                'externalEmrDocumentId',
                'Required parameter "externalEmrDocumentId" was null or undefined when calling updatePalReauthEmrDocumentSelection().'
            );
        }

        if (requestParameters['updatePalReauthEmrDocumentSelectionRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePalReauthEmrDocumentSelectionRequest',
                'Required parameter "updatePalReauthEmrDocumentSelectionRequest" was null or undefined when calling updatePalReauthEmrDocumentSelection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-reauth-submissions/{id}/emr-document-selections/{external_emr_document_id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{external_emr_document_id}', encodeURIComponent(String(requestParameters['externalEmrDocumentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePalReauthEmrDocumentSelectionRequestToJSON(requestParameters['updatePalReauthEmrDocumentSelectionRequest']),
        };
    }

    /**
     * Selection lives in its own join table so the EMR documents stay generic and two submissions for the same patient can select different documents.
     * Mark or unmark an external EMR document for this concurrent review
     */
    async updatePalReauthEmrDocumentSelectionRaw(requestParameters: UpdatePalReauthEmrDocumentSelectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePalReauthEmrDocumentSelection200Response>> {
        const requestOptions = await this.updatePalReauthEmrDocumentSelectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePalReauthEmrDocumentSelection200ResponseFromJSON(jsonValue));
    }

    /**
     * Selection lives in its own join table so the EMR documents stay generic and two submissions for the same patient can select different documents.
     * Mark or unmark an external EMR document for this concurrent review
     */
    async updatePalReauthEmrDocumentSelection(requestParameters: UpdatePalReauthEmrDocumentSelectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePalReauthEmrDocumentSelection200Response> {
        const response = await this.updatePalReauthEmrDocumentSelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePalReauthReportGeneration without sending the request
     */
    async updatePalReauthReportGenerationRequestOpts(requestParameters: UpdatePalReauthReportGenerationOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePalReauthReportGeneration().'
            );
        }

        if (requestParameters['reportGenerationId'] == null) {
            throw new runtime.RequiredError(
                'reportGenerationId',
                'Required parameter "reportGenerationId" was null or undefined when calling updatePalReauthReportGeneration().'
            );
        }

        if (requestParameters['updatePalReauthReportGenerationRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePalReauthReportGenerationRequest',
                'Required parameter "updatePalReauthReportGenerationRequest" was null or undefined when calling updatePalReauthReportGeneration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-reauth-submissions/{id}/report-generations/{report_generation_id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{report_generation_id}', encodeURIComponent(String(requestParameters['reportGenerationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePalReauthReportGenerationRequestToJSON(requestParameters['updatePalReauthReportGenerationRequest']),
        };
    }

    /**
     * Update the overridden report text of a PAL reauth report generation
     */
    async updatePalReauthReportGenerationRaw(requestParameters: UpdatePalReauthReportGenerationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthReportGeneration201Response>> {
        const requestOptions = await this.updatePalReauthReportGenerationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthReportGeneration201ResponseFromJSON(jsonValue));
    }

    /**
     * Update the overridden report text of a PAL reauth report generation
     */
    async updatePalReauthReportGeneration(requestParameters: UpdatePalReauthReportGenerationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthReportGeneration201Response> {
        const response = await this.updatePalReauthReportGenerationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePalReauthSubmission without sending the request
     */
    async updatePalReauthSubmissionRequestOpts(requestParameters: UpdatePalReauthSubmissionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePalReauthSubmission().'
            );
        }

        if (requestParameters['updatePalReauthSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePalReauthSubmissionRequest',
                'Required parameter "updatePalReauthSubmissionRequest" was null or undefined when calling updatePalReauthSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/pal-reauth-submissions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePalReauthSubmissionRequestToJSON(requestParameters['updatePalReauthSubmissionRequest']),
        };
    }

    /**
     * Update a re-auth cycle
     */
    async updatePalReauthSubmissionRaw(requestParameters: UpdatePalReauthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePalReauthSubmission201Response>> {
        const requestOptions = await this.updatePalReauthSubmissionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePalReauthSubmission201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a re-auth cycle
     */
    async updatePalReauthSubmission(requestParameters: UpdatePalReauthSubmissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePalReauthSubmission201Response> {
        const response = await this.updatePalReauthSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePayerContractById without sending the request
     */
    async updatePayerContractByIdRequestOpts(requestParameters: UpdatePayerContractByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContractId'] == null) {
            throw new runtime.RequiredError(
                'payerContractId',
                'Required parameter "payerContractId" was null or undefined when calling updatePayerContractById().'
            );
        }

        if (requestParameters['payerContractUpdate'] == null) {
            throw new runtime.RequiredError(
                'payerContractUpdate',
                'Required parameter "payerContractUpdate" was null or undefined when calling updatePayerContractById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/payer-contracts/{payer_contract_id}`;
        urlPath = urlPath.replace('{payer_contract_id}', encodeURIComponent(String(requestParameters['payerContractId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PayerContractUpdateToJSON(requestParameters['payerContractUpdate']),
        };
    }

    /**
     * Update payer contract by id
     */
    async updatePayerContractByIdRaw(requestParameters: UpdatePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updatePayerContractByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update payer contract by id
     */
    async updatePayerContractById(requestParameters: UpdatePayerContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePayerContractByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updatePayerContractStructuredContract without sending the request
     */
    async updatePayerContractStructuredContractRequestOpts(requestParameters: UpdatePayerContractStructuredContractRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['payerContractId'] == null) {
            throw new runtime.RequiredError(
                'payerContractId',
                'Required parameter "payerContractId" was null or undefined when calling updatePayerContractStructuredContract().'
            );
        }

        if (requestParameters['structuredContract'] == null) {
            throw new runtime.RequiredError(
                'structuredContract',
                'Required parameter "structuredContract" was null or undefined when calling updatePayerContractStructuredContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/payer-contracts/{payer_contract_id}/structured-contract`;
        urlPath = urlPath.replace('{payer_contract_id}', encodeURIComponent(String(requestParameters['payerContractId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StructuredContractToJSON(requestParameters['structuredContract']),
        };
    }

    /**
     * Update structured contract data for a payer contract
     */
    async updatePayerContractStructuredContractRaw(requestParameters: UpdatePayerContractStructuredContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updatePayerContractStructuredContractRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update structured contract data for a payer contract
     */
    async updatePayerContractStructuredContract(requestParameters: UpdatePayerContractStructuredContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePayerContractStructuredContractRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for validatePalNpi without sending the request
     */
    async validatePalNpiRequestOpts(requestParameters: ValidatePalNpiOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['validatePalNpiRequest'] == null) {
            throw new runtime.RequiredError(
                'validatePalNpiRequest',
                'Required parameter "validatePalNpiRequest" was null or undefined when calling validatePalNpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/npi/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidatePalNpiRequestToJSON(requestParameters['validatePalNpiRequest']),
        };
    }

    /**
     * Validate an NPI number against the NPPES registry
     */
    async validatePalNpiRaw(requestParameters: ValidatePalNpiOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidatePalNpi200Response>> {
        const requestOptions = await this.validatePalNpiRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidatePalNpi200ResponseFromJSON(jsonValue));
    }

    /**
     * Validate an NPI number against the NPPES registry
     */
    async validatePalNpi(requestParameters: ValidatePalNpiOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidatePalNpi200Response> {
        const response = await this.validatePalNpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FindAllPalReauthSubmissionsSortByEnum = {
    NextReviewDate: 'next_review_date',
    DateCreated: 'date_created',
    FirstName: 'first_name',
    LastName: 'last_name',
} as const;
export type FindAllPalReauthSubmissionsSortByEnum = typeof FindAllPalReauthSubmissionsSortByEnum[keyof typeof FindAllPalReauthSubmissionsSortByEnum];
/**
 * @export
 */
export const FindAllPalReauthSubmissionsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type FindAllPalReauthSubmissionsSortOrderEnum = typeof FindAllPalReauthSubmissionsSortOrderEnum[keyof typeof FindAllPalReauthSubmissionsSortOrderEnum];
/**
 * @export
 */
export const FindAllPalReauthSubmissionsPresetEnum = {
    NotSubmitted: 'notSubmitted',
    InReview: 'inReview',
    Following: 'following',
    Archive: 'archive',
    All: 'all',
} as const;
export type FindAllPalReauthSubmissionsPresetEnum = typeof FindAllPalReauthSubmissionsPresetEnum[keyof typeof FindAllPalReauthSubmissionsPresetEnum];
/**
 * @export
 */
export const FindAllCarveOutTrackingSortByEnum = {
    CreatedAt: 'created_at',
    FirstName: 'first_name',
    LastName: 'last_name',
    TotalDailyCost: 'total_daily_cost'
} as const;
export type FindAllCarveOutTrackingSortByEnum = typeof FindAllCarveOutTrackingSortByEnum[keyof typeof FindAllCarveOutTrackingSortByEnum];
/**
 * @export
 */
export const FindAllCarveOutTrackingSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FindAllCarveOutTrackingSortOrderEnum = typeof FindAllCarveOutTrackingSortOrderEnum[keyof typeof FindAllCarveOutTrackingSortOrderEnum];
/**
 * @export
 */
export const FindAllCarveOutTrackingPresetEnum = {
    NotSubmitted: 'notSubmitted',
    InReview: 'inReview',
    Following: 'following',
    Archive: 'archive',
    All: 'all'
} as const;
export type FindAllCarveOutTrackingPresetEnum = typeof FindAllCarveOutTrackingPresetEnum[keyof typeof FindAllCarveOutTrackingPresetEnum];
/**
 * @export
 */
export const FindAllPalSubmissionsSortByEnum = {
    StatusUpdatedAt: 'status_updated_at',
    CreatedAt: 'created_at',
    FirstName: 'first_name',
    LastName: 'last_name',
} as const;
export type FindAllPalSubmissionsSortByEnum = typeof FindAllPalSubmissionsSortByEnum[keyof typeof FindAllPalSubmissionsSortByEnum];
/**
 * @export
 */
export const FindAllPalSubmissionsSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;
export type FindAllPalSubmissionsSortOrderEnum = typeof FindAllPalSubmissionsSortOrderEnum[keyof typeof FindAllPalSubmissionsSortOrderEnum];
/**
 * @export
 */
export const FindAllPalSubmissionsPresetEnum = {
    NotSubmitted: 'notSubmitted',
    InReview: 'inReview',
    Following: 'following',
    Archive: 'archive',
    All: 'all',
} as const;
export type FindAllPalSubmissionsPresetEnum = typeof FindAllPalSubmissionsPresetEnum[keyof typeof FindAllPalSubmissionsPresetEnum];
/**
 * @export
 */
export const FindAllPalSubmissionsBenefitsVerifiedEnum = {
    Only: 'only',
    Exclude: 'exclude',
} as const;
export type FindAllPalSubmissionsBenefitsVerifiedEnum = typeof FindAllPalSubmissionsBenefitsVerifiedEnum[keyof typeof FindAllPalSubmissionsBenefitsVerifiedEnum];
/**
 * @export
 */
export const UnmarkPayerTypeAsInnTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Other: 'Other',
} as const;
export type UnmarkPayerTypeAsInnTypeEnum = typeof UnmarkPayerTypeAsInnTypeEnum[keyof typeof UnmarkPayerTypeAsInnTypeEnum];
